import type { FieldErrors } from 'react-hook-form';
import { toSnakeCase } from '@/shared/utils/string';
import { extractErrorMessages } from '@/shared/utils/typeGuards';

export type ServerErrors = Partial<Record<string, string[]>>;

export function hasFieldError(field: string, errors: FieldErrors, serverErrors?: ServerErrors): boolean {
  return Boolean(errors[field] ?? serverErrors?.[toSnakeCase(field)]);
}

export function errorMessagesOr(error: unknown, fallback: string): Record<string, string[]> {
  if (!error) return {};

  const fieldErrors = extractErrorMessages(error);
  return Object.keys(fieldErrors).length > 0 ? fieldErrors : { base: [fallback] };
}
